function e(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
export {
  e as g
};
//# sourceMappingURL=_commonjsHelpers-C6fGbg64.js.map
